module.exports = __webpack_public_path__ + "static/media/size.a42e2edd.svg";